<template>
  <div>
    <vx-card title="Test Status" class="mb-3">
    <div class="vx-row" id="formulation_qa_table">

      <div class="vx-col w-full">

        <b class="mt-4" v-if="qa_comments.length === 0">No data available</b>

        <span v-for="comment of qa_comments">
                <vs-alert class="mt-4" :color="commentColorFactory(comment.description)"
                          :title="comment.description + ' - ' + __dateTimeFormatter(comment.created_at)" active="true">
                  {{ comment.comment }}
                </vs-alert>
            </span>

      </div>
    </div>
    </vx-card>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const FormulationsRepository = RepositoryFactory.get('formulations')

export default {
  name: "FormulationQaTab",
  components: {},
  props: {
    formulation_data: {
      type: Object,
      default: {},
    }
  },
  data() {
    return {
      formulationId: '',
      qa_comments: []
    }
  },
  methods: {
    async loadFormulations() {
      await this.$vs.loading({
        container: '#formulation_qa_table',
        scale: 0.45
      })
      const {data} = await FormulationsRepository.details(this.formulationId)
      this.formulation = data.data
      this.qa_comments = this.formulation.qa_comments
      this.$vs.loading.close('#formulation_qa_table > .con-vs-loading')
    },
    commentColorFactory(flag) {
      if (flag === 'Approved by QA') {
        return '#8fd9a8'
      }
      if (flag === 'Rejected by QA') {
        return '#f05945'
      }
    }
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    this.qa_comments = this.formulation.qa_comments
    // await this.loadFormulations()
  },
  computed: {
    formulation: function () {
      return this.formulation_data
    }
  },
  watch: {
    formulation_data: {
      deep: true,
      handler() {
        this.qa_comments = this.formulation.qa_comments
      }
    }
  },
  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style scoped>

.__table-heading-small {
  font-size: x-small;
  font-weight: normal;
}

</style>
